import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  dashboardWrapper: {
    flex: 1,
  },
  card: {
    padding: theme.spacing(3),
    borderRadius: 24,
    border: '1px solid #f3f4f6',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    backgroundColor: '#ffffff',
    transition: 'box-shadow 0.3s ease-in-out',
    '&:hover': {
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    overflow: 'hidden',
    height: '100%',
    textDecoration: 'none !important',
  },
  cardIconContainer: {
    padding: theme.spacing(1.5),
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  blueIconBg: {
    backgroundColor: '#eff6ff',
    color: '#2563eb',
  },
  blueDarkIconBg: {
    backgroundColor: '#2563eb',
    color: '#ffffff',
  },
  badge: {
    fontSize: 10,
    fontWeight: 'bold',
    padding: '4px 8px',
    borderRadius: 8,
  },
  blueBadge: {
    backgroundColor: '#eff6ff',
    color: '#2563eb',
  },
  grayBadge: {
    backgroundColor: '#f3f4f6',
    color: '#2563eb',
    border: '1px solid #dbeafe',
  },
  cardTitle: {
    color: '#6b7280',
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  cardValue: {
    color: '#2563eb',
    fontWeight: 700,
    fontSize: '2.25rem',
    lineHeight: 1,
  },
  unitText: {
    fontSize: '1rem',
    fontWeight: 400,
    color: '#9ca3af',
    marginLeft: theme.spacing(1),
  },
  sectionTitle: {
    fontSize: '1.25rem',
    fontWeight: 700,
    color: '#1f2937',
  },
  sectionSubtitle: {
    fontSize: '0.75rem',
    color: '#9ca3af',
  },
  chartContainer: {
    position: 'relative',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    minHeight: 300,
  },
  legendGrid: {
    marginTop: theme.spacing(2),
  },
  legendItem: {
    backgroundColor: '#f9fafb',
    padding: theme.spacing(1.5),
    borderRadius: 16,
    border: '1px solid #f3f4f6',
  },
  legendDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    marginRight: theme.spacing(1),
  },
  legendLabel: {
    fontSize: 10,
    color: '#6b7280',
  },
  legendValue: {
    fontSize: '0.875rem',
    fontWeight: 700,
  },
  representativeCard: {
    padding: theme.spacing(3),
    borderRadius: 24,
    border: '1px solid #f3f4f6',
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    textDecoration: 'none !important',
  },
  representativeTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#6b7280',
    marginBottom: theme.spacing(1),
  },
  representativeTitleBlue: {
    color: '#2563eb',
  },
  representativeValue: {
    fontSize: '1.875rem',
    fontWeight: 700,
    color: '#1f2937',
  },
  representativeValueBlue: {
    color: '#1d4ed8',
  },
  deptItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: '#f9fafb',
    borderRadius: 16,
    border: '1px solid #f3f4f6',
  },
  deptDot: {
    width: 16,
    height: 16,
    borderRadius: '50%',
    marginRight: theme.spacing(1.5),
  },
  breadcrumbContainer: {
    padding: theme.spacing(2, 0, 4, 0),
    '& .MuiBreadcrumbs-ol': {
      alignItems: 'center',
    }
  },
  breadcrumbLink: {
    display: 'flex',
    alignItems: 'center',
    color: '#6b7280',
    backgroundColor: '#f3f4f6',
    padding: '8px 16px',
    borderRadius: '12px',
    fontSize: '0.875rem',
    fontWeight: 500,
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',
    textDecoration: 'none !important',
    '&:hover': {
      backgroundColor: '#e5e7eb',
      color: '#1f2937',
    },
    '& svg': {
      marginRight: theme.spacing(0.5),
      fontSize: '1.1rem',
    }
  },
  activeBreadcrumb: {
    backgroundColor: '#eff6ff',
    color: '#2563eb',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#dbeafe',
      color: '#1d4ed8',
    }
  }
}));

export default styles;